import * as React from 'react';
import { useContext } from 'react';
import {AppContext} from "../../context/AppContext";

export const LoadingIndicator = () => {
  const {
    I18N,
    loadingProgress
  } = useContext(AppContext);

  return (
    <>
      <dia-loader-overlay>
        <dia-loader
          data-progress={ loadingProgress }
          data-message={ I18N.t("Es wird geladen...") }
        ></dia-loader>
      </dia-loader-overlay>
    </>
  );
};
